import { pulse } from '@prenuvo/pulse';

import { handleApiError } from './util';

export const httpClient = pulse({
  baseURL: import.meta.env.VITE_BDB_SERVER_URL,
  onError: handleApiError,
});
